export default "__VITE_ASSET__DOyF8Qdy__"